import React from "react";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import OrderTag from "@/enum/OrderTag";
import ShopType from "@/enum/ShopType";
import ShopDTO from "@/dto/shop/ShopDTO";

interface PddAvailableLogisticsRecommendProps {
    order: OrderDTO;

    shop: ShopDTO;
}

export function shouldRenderPddAvailableLogisticsRecommend(order: OrderDTO, shop: ShopDTO) {
    return shop.type === ShopType.PINDUODUO && !!order.tags?.includes(OrderTag.PDD_REGION_BLACK_DELAY_SHIPPING);
}

/**
 * 可延迟发货提示
 */
const PddAvailableLogisticsRecommend: React.FC<PddAvailableLogisticsRecommendProps> = function (props) {
    const { order, shop } = props;

    const orderManagementStore = useOrderManagementStore();

    if (!orderManagementStore) {
        return null;
    }

    if (!shouldRenderPddAvailableLogisticsRecommend(order, shop)) {
        return null;
    }

    const hasPddRegionDelayShippingTag = order?.tags?.find((tag) => tag === OrderTag.PDD_REGION_BLACK_DELAY_SHIPPING);

    let tooltip = null;
    let title = null;
    let logisticsCompaniesEls = null;

    // 优先可延迟发货订单
    if (hasPddRegionDelayShippingTag) {
        if (logisticsCompaniesEls) {
            title = (
                <>
                    该订单<span className="text-primary">发货时间可延迟</span>，如快递停运，可使用
                    {logisticsCompaniesEls}
                    发货
                </>
            );

            tooltip = (
                <div>
                    <p className="mb3">如您常用的快递停运，可使用{logisticsCompaniesEls}发货</p>
                    <p>1. 平台为您查询到与该订单物流线路相似的包裹，刚刚已通过上述快递成功发出</p>
                    <p>2. 受疫情等客观因素影响，若该订单发货时间延迟，平台不做处罚；若能及时发货，可提升店铺曝光量。</p>
                    <p>
                        3.
                        当该订单收货区域解除疫情等客观因素影响时，在解除当日订单将重启承诺发货时间倒计时，请您密切关注变化，按照承诺发货时间发货，否则将受平台处罚。
                    </p>
                </div>
            );
        } else {
            title = (
                <>
                    受客观因素影响，该订单<span className="text-primary">发货时间可延迟</span>
                </>
            );

            tooltip = (
                <div>
                    <p>1.受疫情等客观因素影响，快递可能无法正常配送；若该订单发货时间延迟，平台不做处罚；</p>
                    <p>
                        2.当该订单收货区域解除上述影响时，解除当日订单将重启承诺发货时间倒计时，请您密切关注变化，按照承诺发货时间发货，否则将受平台处罚
                    </p>
                </div>
            );
        }
    }

    if (title && tooltip) {
        return (
            <div className="mb3">
                <Tooltip
                    styles={{
                        root: {
                            maxWidth: 320,
                        },
                        body: {
                            color: "#333",
                        },
                    }}
                    color="white"
                    title={tooltip}
                >
                    <span style={{ color: "#333", borderBottom: "1px #aaa dashed" }}>{title}</span>
                </Tooltip>
            </div>
        );
    }

    return null;
};

export default observer(PddAvailableLogisticsRecommend);
